import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  model,
  ModelSignal,
  Signal
} from '@angular/core';
import { select, Store } from '@ngxs/store';
import { NgClass } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { SidebarWrapperComponent } from '../../../shared/components/wrappers/sidebar-wrapper/sidebar-wrapper.component';
import { AuthState } from '../../../shared/state/auth/auth.state';
import { AuthActions } from '../../../shared/state/auth/auth.actions';
import { environment } from '../../../../environments/environment';
import { AuthDialogService } from '../../../modules/auth/services/auth-dialog.service';
import { ClearUserProfileAction } from '../../../shared/state/user-profile/user-profile.actions';

interface SidebarMenuItem {
  name: string;
  icon: string;
  route?: string;
  action?: () => void;
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  imports: [NgClass, RouterLink, SidebarWrapperComponent],
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarComponent {
  private readonly store = inject(Store);
  private readonly authDialog = inject(AuthDialogService);
  private readonly router = inject(Router);

  isOpen: ModelSignal<boolean> = model<boolean>(false);
  isAuthenticated: Signal<boolean> = select(AuthState.isAuthenticated);

  protected readonly headerLinks: { label: string; url: string }[] =
    (environment as { headerLinks?: { label: string; url: string }[] }).headerLinks || [];

  protected readonly menus = computed<SidebarMenuItem[]>(() => {
    const menus: SidebarMenuItem[] = [
      {
        name: 'Home',
        icon: 'icon-home-outline',
        route: '/',
        action: () => this.isOpen.set(false)
      }
      // {
      //   name: 'Orders',
      //   icon: 'icon-clipboard-outline',
      //   route: '/orders',
      //   action: () => {
      //     this.isOpen.set(false);
      //   }
      // },
      // {
      //   name: 'My Account',
      //   icon: 'icon-user-circle-outline',
      //   route: '/my-account',
      //   action: () => {
      //     this.isOpen.set(false);
      //   }
      // },
      // { TODO: According to https://app.asana.com/0/1209401032829742/1209501594677105
      //   name: 'Payment',
      //   icon: 'icon-credit-card-outline',
      //   route: '/payment'
      // },
      // {
      //   name: 'Gift Card',
      //   icon: 'icon-gift-outline',
      //   route: '/gift-card',
      //   action: () => {
      //     this.isOpen.set(false);
      //   }
      // }
    ];

    if (this.isAuthenticated()) {
      menus.push({
        name: 'Sign out',
        icon: 'icon-lock-open-outline',
        action: () => this.logout()
      });
    } else {
      menus.push({
        name: 'Login',
        icon: 'icon-lock-closed-outline',
        action: () => this.openSignIn()
      });
    }

    return menus;
  });

  private logout(): void {
    this.store.dispatch([
      new AuthActions.ClearUser(),
      new ClearUserProfileAction()
    ]);
    this.isOpen.set(false);

    if (this.router.url.startsWith('/my-account')) {
      void this.router.navigate(['/']);
    }
  }

  private openSignIn(): void {
    this.isOpen.set(false);
    void this.authDialog.openSignIn();
  }
}
